export default __webpack_public_path__ + "static/media/cardiac-chair-demo.089ba211.png";